import React from 'react';
import ManualAddProductPage from './ManualAddProductPage';
import BulkAddProductsPage from './BulkAddProductsPage';
import { useProductsChildRoute } from './productsNavigation';
import './ManageProducts.css';

// `method` comes from the URL (/products/add/manual | /products/add/bulk).
function AddProductsPage({ method }) {
  const { openChild: handleMethodSelect } = useProductsChildRoute('add');

  if (method === 'manual') {
    return <ManualAddProductPage />;
  }

  if (method === 'bulk') {
    return <BulkAddProductsPage />;
  }

  // Method selection screen
  return (
    <div className="addProductsContainer">
      <div className="header">
        <h1 className="title">Add Products</h1>
        <div className="headerInfo">
          <span className="infoBadge">Choose Method</span>
        </div>
      </div>
      
      <div className="methodSelection">
        <h2 className="selectionTitle">How would you like to add products?</h2>
       
        
        <div className="methodCards">
          {/* Manual Entry Card */}
          <div 
            className="methodCard"
            onClick={() => handleMethodSelect('manual')}
          >
            <div className="cardIcon">📝</div>
            <h3 className="cardTitle">Manual Entry</h3>
            <p className="cardDescription">
              Add a single product using a guided form </p>
            <button className="selectMethodButton">
              Select Manual Entry →
            </button>
          </div>
          
          {/* Bulk Upload Card */}
          <div 
            className="methodCard"
            onClick={() => handleMethodSelect('bulk')}
          >
            <div className="cardIcon">📊</div>
            <h3 className="cardTitle">Bulk Upload</h3>
            <p className="cardDescription">
              Upload multiple products at once using a spreadsheet (CSV or Excel)
            </p>

            <button className="selectMethodButton">
              Select Bulk Upload →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProductsPage;
